export class ApiBaseGuest {
	public static API_VERSION = '/guest' as const;

	protected get baseUri() {
		return [ApiBaseGuest.API_VERSION, this.endpoint].filter(Boolean).join('/');
	}

	constructor(private readonly endpoint?: string) {
		// Empty
	}
}
